export const SKILL_NAME_MAX = 256
export const SKILL_DESCRIPTION_MAX = 2000
export const SKILL_CONTENT_MAX = 50000
